import routerOptions0 from "/home/vsts/work/1/s/src/app/router.options.ts";
import routerOptions1 from "/home/vsts/work/1/s/src/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}